// extracted by mini-css-extract-plugin
export var border = "_1t-8";
export var brand = "_1t-t";
export var button = "_1t-l";
export var center = "_1t-a";
export var centered = "_1t-6";
export var closeButton = "_1t-c";
export var disabledWrapper = "_1t-m";
export var error = "_1t-p";
export var extraLarge = "_1t-4";
export var extraSmall = "_1t-1";
export var fill = "_1t-i";
export var footer = "_1t-h";
export var footerAction = "_1t-j";
export var footerButtons = "_1t-k";
export var header = "_1t-7";
export var headerWithClose = "_1t-d";
export var icon = "_1t-o";
export var info = "_1t-s";
export var inline = "_1t-9";
export var large = "_1t-3";
export var main = "_1t-e";
export var modal = "_1t-0";
export var nearFull = "_1t-5";
export var neutral = "_1t-u";
export var noPadding = "_1t-g";
export var none = "_1t-v";
export var scrollable = "_1t-f";
export var small = "_1t-2";
export var success = "_1t-r";
export var tight = "_1t-n";
export var titleIcon = "_1t-b";
export var warn = "_1t-q";